import React, { useEffect } from "react";
import { ServiceCard } from "./BrainServices";
import servicesData from "../components/utility/ServiceData";
import { Helmet } from "../components/common/Helmet";

const NerveServices: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        //eslint-disable-next-line
    }, [])
    const serviceEnteries = Object.entries(servicesData).slice(14, 17);
    return (
        <>
            <Helmet>
                <title>Peripheral Nerve Surgery Services | Dr. Gangesh Gunjan | Sarvodaya Hospital</title>
                <meta name="description" content="Peripheral nerve surgery in Noida & Greater Noida with 12+ years clinical experience. Evaluation and treatment for Sciatica, Carpal Tunnel Syndrome, and Nerve Entrapment Disorders." />
                <meta name="keywords" content="nerve surgeon Noida, Dr. Gangesh Gunjan, carpal tunnel surgery, sciatica treatment, peripheral nerve disorders, neurosurgery, Sarvodaya Hospital" />
            </Helmet>

            <div className="bg-gradient-to-b from-gray-50 to-white">
                <div className="container mx-auto px-4 py-16 mt-28">
                    <div className="max-w-4xl mx-auto mb-16">
                        <h2 className="text-4xl font-bold mb-12 text-center text-blue-900">Nerve Services</h2>
                        
                        <div className="space-y-8 text-lg leading-relaxed">
                            <p className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-blue-800">
                                When conservative management such as physical therapy and medications does not relieve symptoms of nerve compression, surgical intervention may be considered. Dr. Gangesh Gunjan brings over 12 years of clinical experience in evaluating and treating peripheral nerve disorders in Noida and Greater Noida. Surgical indications are evaluated following detailed clinical examination and neuro-electrophysiological studies.
                            </p>
                            
                            <p className="bg-white p-6 rounded-lg shadow-sm">
                                During consultation, our clinical team discusses diagnostic findings, conservative alternatives, procedure options, and potential risks. Whether evaluating Sciatica, Carpal Tunnel Syndrome, or peripheral nerve compression, we guide patients through transparent, evidence-based care. Get in touch to schedule an evaluation.
                            </p>
                        </div>
                    </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {serviceEnteries.map(([slug, service]) => (
                        <ServiceCard
                            key={slug}
                            title={service.title}
                            description={service.description}
                            slug={slug}
                        />
                    ))}
                </div>
            </div>
            </div>
        </>
    )
}

export default NerveServices;